<template lang="pug">
  component(:is="flaggedComponent" v-bind="$props" v-on="$attrs")
</template>

<script>
import WorkflowsOld from './WorkflowsOld.vue';
import WorkflowsNew from './WorkflowsNew.vue';
import { mapState } from 'vuex';

export default {
  name: 'WorkflowsWrapper',
  components: {
    WorkflowsOld,
    WorkflowsNew,
  },
  computed: {
    ...mapState({
      featureFlags: state => state.featureFlags.FEATURE_FLAGS,
    }),
    flaggedComponent() {
      return this.featureFlags?.SHOW_NEW_WORKFLOW_DESIGN ? WorkflowsNew : WorkflowsOld;
    },
  },
};
</script>
